enum LocationWorkerType {
	Favourite           = 1,
	Blocked             = 2,
}

export default LocationWorkerType;